import { render, staticRenderFns } from "./HolidayListAddNew.vue?vue&type=template&id=28efddea&"
import script from "./HolidayListAddNew.vue?vue&type=script&lang=js&"
export * from "./HolidayListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./HolidayListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports